import { useContext } from 'react';
import AlertContext from '../../context/alert/alertContext';

const Alert = () => {
  const alertContext = useContext(AlertContext);

  const { alert } = alertContext;

  return (
    alert !== null && (
      <div className={`alert alert-${alert.type}`}>
        <i className="fa-solid fa-exclamation-circle me-2" />
        {alert.msg}
      </div>
    )
  );
};

export default Alert;
